// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"d0d5110d","572":"9ac47e81","688":"856ccb90","821":"a7c66ee8"}[chunkId] + ".chunk.js";
};